import { render, staticRenderFns } from "./flashcards.vue?vue&type=template&id=22136678&scoped=true"
import script from "./flashcards.vue?vue&type=script&lang=js"
export * from "./flashcards.vue?vue&type=script&lang=js"
import style0 from "./flashcards.vue?vue&type=style&index=0&id=22136678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22136678",
  null
  
)

export default component.exports